import { render, staticRenderFns } from "./task-v2.vue?vue&type=template&id=66547fee&scoped=true&"
import script from "./task-v2.vue?vue&type=script&lang=js&"
export * from "./task-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66547fee",
  null
  
)

export default component.exports